// ConnectedProjectView.jsx
import React from "react";
import "../ConnectedProjectView.css";
import ProjectCard from "./ProjectCard";
import ExpandedProjectView from "./ExpandedProjectView";
import { Row } from "react-bootstrap";

const ConnectedProjectView = ({ projects }) => {
  const [selectedProject, setSelectedProject] = React.useState(null);

  const handleProjectSelect = (project) => {
    setSelectedProject(project);
  };

  return (
    <div className="connected-project-view">
      <div className="project-list mb-1">
        <Row>
          {projects.map((project) => (
            <ProjectCard
              key={project._id}
              project={project}
              isJoined={project.joinStatus === "approved"}
              onClick={() => handleProjectSelect(project)}
              isSelected={
                selectedProject && selectedProject._id === project._id
              }
              isFlippable={false}
            />
          ))}
        </Row>
      </div>
      {selectedProject?.joinStatus === "approved" && (
        <div className="expanded-view-container">
          <ExpandedProjectView project={selectedProject} />
        </div>
      )}
    </div>
  );
};

export default ConnectedProjectView;
